import { Box, Button, Typography } from '@mui/material'
import { backButtonSx, ButtonLabel, contentErrorCodeSx, contentHeaderSx, contentMessageSx } from './ErrorContent.styles'
import { Trans } from 'react-i18next'
import { ArrowLeft } from 'react-feather'
import { useNavigate } from 'react-router-dom'
import { t } from 'i18next'

type ErrorContentProps = {
	errorCode: string
	errorHeader: string
	errorMessage: string
}

export default function ErrorContent({ errorCode, errorHeader, errorMessage }: ErrorContentProps) {
	const navigate = useNavigate()
	return (
		<Box display="flex" flexDirection="column" justifyContent="center">
			<Typography variant="h1" sx={contentErrorCodeSx}>
				<Trans i18nKey={errorCode} />
			</Typography>
			<Typography variant="h3" sx={contentHeaderSx}>
				<Trans i18nKey={errorHeader} components={{ br: <br /> }} />
			</Typography>
			<Typography variant="h5" sx={contentMessageSx}>
				<Trans i18nKey={errorMessage} components={{ br: <br /> }} />
			</Typography>
			<Button sx={backButtonSx} onClick={() => navigate('/home')}>
				<ArrowLeft width="16px" />
				<ButtonLabel>{t('error.btn_label')}</ButtonLabel>
			</Button>
		</Box>
	)
}
